<div class="fullcontainer">
  <br />
  <br />

  @if (this.isServerError) {
    <div class="alert alert-danger noPrint">Something went wrong. Please try again later.</div>
  }

  <div class='titleContainer noPrint'>
    <h2 class='header' style='color: #006498'>Product Label - {{ this.product.name }}</h2>

    <div>
      <button class='btn btn-secondary' (click)='this.print()'><i class="fas fa-print"></i> Print</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/quoting/products'><i class="fas fa-arrow-left"></i> Back</button>&nbsp;
    </div>
  </div>
  <app-label-print-setup></app-label-print-setup>
  <br />

  <app-stock-label
    scanType='product'
    [recordId]='this.product.id'
    [title]='this.product.name'
    [subtitle]='this.getSku()'
    [reference]='this.product.supplierCode'
  ></app-stock-label>
</div>
